export const TicketingClosed = () => {
  return (
    <div className="flex flex-col items-center">
      <h1 className="text-xl font-medium pb-2">
        Presale closed. You can still get tickets at the door for 15 EUR.
      </h1>
      <div>
        <h3 className="mt-4 text-lg font-medium">Entry</h3>
        <p className="my-2">23:00 until 08:00</p>
        <h3 className="mt-4 text-lg font-medium">Location</h3>
        <p className="my-2">
          Club M01, Berlin <br />
          Markgrafendamm 1, 10245 Berlin <br />
          <a href="https://maps.app.goo.gl/UEKQZTEa5Ep1QFH98">Open in google maps</a>
        </p>
      </div>
    </div>
  );
};
